import {Dialog} from "@mui/material"
import OpenLogin, {OPENLOGIN_NETWORK_TYPE} from "@toruslabs/openlogin"
import {useCallback} from "react"
import {AppConfig} from "../../../App.config"
import {clearIPFSOrbit} from "../../../functions/ipfs-orbit"
import styles from "./index.module.scss"
import web3authImg from "../../../assets/auth_web3auth.png"
import phantomImg from "../../../assets/auth_phantom.png"

interface AuthSelectorProps {
  open: boolean
  onClose: () => void
}

export const AuthSelector = (props: AuthSelectorProps) => {
  const {open, onClose} = props

  const onClickWeb3Auth = useCallback(async () => {
    const openLogin = new OpenLogin({
      clientId: AppConfig.openLoginClientId,
      network: AppConfig.openLoginNetwork as OPENLOGIN_NETWORK_TYPE,
    })
    await openLogin.init()

    try {
      await openLogin.login()
    } catch (e) {
      return
    }

    await clearIPFSOrbit()
    localStorage.setItem("method", "web3auth")
  }, [])

  const onClickPhantom = useCallback(async () => {
    // @ts-ignore
    const provider = window.phantom?.solana
    const isPhantomInstalled = provider?.isPhantom
    if (!isPhantomInstalled) {
      return
    }

    try {
      await provider.connect()
    } catch (e) {
      return
    }

    const encodedMessage = new TextEncoder().encode(
      "Sign in on DeGit"
    )
    const signedMessage = await provider.signMessage(encodedMessage, "utf8")
    const json = JSON.stringify(signedMessage)
    await clearIPFSOrbit()
    localStorage.setItem("method", "phantom")
    localStorage.setItem("signedMessage", json)
    window.location.reload()
  }, [])

  return (
    <Dialog open={open}
            onClose={onClose}
            PaperProps={{className: styles.Container}}
    >
      <div className={styles.Title}>Sign in now</div>
      <div className={styles.Subtitle}>
        Onchain request is a feature for end users to make feature requests with cryptocurrency incentive.
        You need to download “DeGit Desktop” for activating the feature.
      </div>
      <div className={styles.Row}>
        <div className={styles.AuthOption} onClick={onClickWeb3Auth}>
          <img src={web3authImg} alt="web3auth" className={styles.AuthOptionImg}/>
          <div>Web3Auth</div>
        </div>

        <div className={styles.AuthOption} onClick={onClickPhantom}>
          <img src={phantomImg} alt="phantom" className={styles.AuthOptionImg}/>
          <div>Phantom</div>
        </div>
      </div>
    </Dialog>
  )
}
